import { Badge } from "@/components/ui/badge";

// Shared pills so the Daily Collections tables read like Loan Ageing / Customer File.
export const gbp = (v) => new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(v || 0);

export const dpdTone = (dpd) => {
  if (!dpd && dpd !== 0) return "bg-slate-100 text-slate-600";
  if (dpd <= 7) return "bg-emerald-100 text-emerald-800";
  if (dpd <= 30) return "bg-amber-100 text-amber-800";
  if (dpd <= 60) return "bg-orange-100 text-orange-800";
  if (dpd <= 90) return "bg-rose-100 text-rose-800";
  return "bg-red-100 text-red-900";
};

const TONES = {
  slate: "bg-slate-50 text-slate-600 border-slate-300",
  emerald: "bg-emerald-50 text-emerald-700 border-emerald-300",
  amber: "bg-amber-50 text-amber-800 border-amber-300",
  sky: "bg-sky-50 text-sky-800 border-sky-300",
  rose: "bg-rose-50 text-rose-700 border-rose-300",
  red: "bg-red-100 text-red-900 border-red-300",
};

export const Pill = ({ tone = "slate", children, testId, title, className = "" }) => (
  <Badge variant="outline" className={`text-[10px] font-medium px-1.5 h-4 whitespace-nowrap ${TONES[tone] || TONES.slate} ${className}`} data-testid={testId} title={title}>
    {children}
  </Badge>
);

export const RestructuredPill = ({ iteration, testId }) => (
  <Badge className="bg-red-600 text-white border-red-700 text-[9px] font-bold tracking-wider px-1.5 h-4 hover:bg-red-700 whitespace-nowrap" data-testid={testId} title={iteration ? `Iteration /${iteration}` : undefined}>
    RESTRUCTURED{iteration > 1 ? ` /${iteration}` : ""}
  </Badge>
);

export const LegalPill = ({ handler, testId }) => (
  <Badge variant="outline" className="bg-red-100 text-red-900 border-red-300 text-[9px] font-bold tracking-wider px-1.5 h-4 whitespace-nowrap" data-testid={testId} title={handler ? `Legal owner ${handler}` : "With Legal"}>
    ⚖ LEGAL{handler ? ` · ${handler.split(" ")[0]}` : ""}
  </Badge>
);

export const DpdPill = ({ dpd, testId }) =>
  dpd > 0 ? (
    <span className={`inline-flex items-center justify-center min-w-[40px] px-2 py-0.5 rounded-full text-xs font-bold tabular-nums ${dpdTone(dpd)}`} data-testid={testId}>{dpd}</span>
  ) : (
    <span className="text-slate-300">—</span>
  );

export const ChasedPill = ({ channel, testId }) => (
  <Pill tone="emerald" testId={testId}>Chased · {String(channel || "").toUpperCase()}</Pill>
);
